import Default from "components/layouts/Guest/Default";
import ExamType from "components/templates/ExamType/ExamType";

const App = () => (
  <Default>
    <ExamType />
  </Default>
);

export default App;
